import React, {useEffect, useState} from 'react';
import './CreateRoleInputName.css';
import FormField from '../FormField/FormField';
const CreateRoleInputName = ({onChange, error, name = ''}) => {
  const [value, setValue] = useState(name);
  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };
  const modifierClassesFormField = {
    label: 'create-role-input-name__label',
    input: 'create-role-input-name__input',
    inputWrapper: '',
    field: 'create-role-input-name',
  };

  useEffect(() => {
    setValue(name);
  }, [name]);
  return (
    <div className='create-role-input-name'>
      {error && <p className='auth-forms__error-message'>{error}</p>}
      <FormField
        required={true}
        modifierClassesFormField={modifierClassesFormField}
        label={'Наименование'}
        value={value}
        onChange={handleChange}
        error={error}
      />
    </div>
  );
};

export default CreateRoleInputName;
